__turbopack_context__.v({
  "breadcrumbsContentWrapper": "breadcrumbs-module-scss-module__BL5njW__breadcrumbsContentWrapper",
  "breadcrumbsWrapper": "breadcrumbs-module-scss-module__BL5njW__breadcrumbsWrapper",
  "mbl": "breadcrumbs-module-scss-module__BL5njW__mbl",
  "mbm": "breadcrumbs-module-scss-module__BL5njW__mbm",
  "mbn": "breadcrumbs-module-scss-module__BL5njW__mbn",
  "mbs": "breadcrumbs-module-scss-module__BL5njW__mbs",
  "mbx": "breadcrumbs-module-scss-module__BL5njW__mbx",
  "mbxl": "breadcrumbs-module-scss-module__BL5njW__mbxl",
  "mbxxl": "breadcrumbs-module-scss-module__BL5njW__mbxxl",
  "ml": "breadcrumbs-module-scss-module__BL5njW__ml",
  "mll": "breadcrumbs-module-scss-module__BL5njW__mll",
  "mlm": "breadcrumbs-module-scss-module__BL5njW__mlm",
  "mln": "breadcrumbs-module-scss-module__BL5njW__mln",
  "mls": "breadcrumbs-module-scss-module__BL5njW__mls",
  "mlx": "breadcrumbs-module-scss-module__BL5njW__mlx",
  "mlxl": "breadcrumbs-module-scss-module__BL5njW__mlxl",
  "mlxxl": "breadcrumbs-module-scss-module__BL5njW__mlxxl",
  "mm": "breadcrumbs-module-scss-module__BL5njW__mm",
  "mn": "breadcrumbs-module-scss-module__BL5njW__mn",
  "mrl": "breadcrumbs-module-scss-module__BL5njW__mrl",
  "mrm": "breadcrumbs-module-scss-module__BL5njW__mrm",
  "mrn": "breadcrumbs-module-scss-module__BL5njW__mrn",
  "mrs": "breadcrumbs-module-scss-module__BL5njW__mrs",
  "mrx": "breadcrumbs-module-scss-module__BL5njW__mrx",
  "mrxl": "breadcrumbs-module-scss-module__BL5njW__mrxl",
  "mrxxl": "breadcrumbs-module-scss-module__BL5njW__mrxxl",
  "ms": "breadcrumbs-module-scss-module__BL5njW__ms",
  "mtl": "breadcrumbs-module-scss-module__BL5njW__mtl",
  "mtm": "breadcrumbs-module-scss-module__BL5njW__mtm",
  "mtn": "breadcrumbs-module-scss-module__BL5njW__mtn",
  "mts": "breadcrumbs-module-scss-module__BL5njW__mts",
  "mtx": "breadcrumbs-module-scss-module__BL5njW__mtx",
  "mtxl": "breadcrumbs-module-scss-module__BL5njW__mtxl",
  "mtxxl": "breadcrumbs-module-scss-module__BL5njW__mtxxl",
  "mx": "breadcrumbs-module-scss-module__BL5njW__mx",
  "mxl": "breadcrumbs-module-scss-module__BL5njW__mxl",
  "mxxl": "breadcrumbs-module-scss-module__BL5njW__mxxl",
  "pbl": "breadcrumbs-module-scss-module__BL5njW__pbl",
  "pbm": "breadcrumbs-module-scss-module__BL5njW__pbm",
  "pbn": "breadcrumbs-module-scss-module__BL5njW__pbn",
  "pbs": "breadcrumbs-module-scss-module__BL5njW__pbs",
  "pbx": "breadcrumbs-module-scss-module__BL5njW__pbx",
  "pbxl": "breadcrumbs-module-scss-module__BL5njW__pbxl",
  "pbxxl": "breadcrumbs-module-scss-module__BL5njW__pbxxl",
  "pl": "breadcrumbs-module-scss-module__BL5njW__pl",
  "pll": "breadcrumbs-module-scss-module__BL5njW__pll",
  "plm": "breadcrumbs-module-scss-module__BL5njW__plm",
  "pln": "breadcrumbs-module-scss-module__BL5njW__pln",
  "pls": "breadcrumbs-module-scss-module__BL5njW__pls",
  "plx": "breadcrumbs-module-scss-module__BL5njW__plx",
  "plxl": "breadcrumbs-module-scss-module__BL5njW__plxl",
  "plxxl": "breadcrumbs-module-scss-module__BL5njW__plxxl",
  "pm": "breadcrumbs-module-scss-module__BL5njW__pm",
  "pn": "breadcrumbs-module-scss-module__BL5njW__pn",
  "prl": "breadcrumbs-module-scss-module__BL5njW__prl",
  "prm": "breadcrumbs-module-scss-module__BL5njW__prm",
  "prn": "breadcrumbs-module-scss-module__BL5njW__prn",
  "prs": "breadcrumbs-module-scss-module__BL5njW__prs",
  "prx": "breadcrumbs-module-scss-module__BL5njW__prx",
  "prxl": "breadcrumbs-module-scss-module__BL5njW__prxl",
  "prxxl": "breadcrumbs-module-scss-module__BL5njW__prxxl",
  "ps": "breadcrumbs-module-scss-module__BL5njW__ps",
  "ptl": "breadcrumbs-module-scss-module__BL5njW__ptl",
  "ptm": "breadcrumbs-module-scss-module__BL5njW__ptm",
  "ptn": "breadcrumbs-module-scss-module__BL5njW__ptn",
  "pts": "breadcrumbs-module-scss-module__BL5njW__pts",
  "ptx": "breadcrumbs-module-scss-module__BL5njW__ptx",
  "ptxl": "breadcrumbs-module-scss-module__BL5njW__ptxl",
  "ptxxl": "breadcrumbs-module-scss-module__BL5njW__ptxxl",
  "px": "breadcrumbs-module-scss-module__BL5njW__px",
  "pxl": "breadcrumbs-module-scss-module__BL5njW__pxl",
  "pxxl": "breadcrumbs-module-scss-module__BL5njW__pxxl",
});
